import { render, staticRenderFns } from "./VerifyDeviceModalComponent.vue?vue&type=template&id=5459955e"
import script from "./VerifyDeviceModalComponent.vue?vue&type=script&lang=js"
export * from "./VerifyDeviceModalComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports